const impressionSegmentEventNames = {
  VIEWED: "Viewed",
  CLICKED: "Clicked",
};

const createViewedSegmentEvent = (element, audience) => {

  const segmentEvent = {
    event: impressionSegmentEventNames.VIEWED,
    properties: {
      element: element,
    },
  }

  if (audience) segmentEvent.properties.audience = audience

  return segmentEvent;
};

const createClickedSegmentEvent = (element, audience) => {

  const segmentEvent = {
    event: impressionSegmentEventNames.CLICKED,
    properties: {
      element: element,
    },
  };

  if (audience) segmentEvent.properties.audience = audience

  return segmentEvent;
};

export { createViewedSegmentEvent, createClickedSegmentEvent };
